import React, { FunctionComponent } from 'react';

import { propsHelperRem, SvgProps } from '@/shared/lib/propsHelper';
import { ToastNotification } from '@/shared/lib/popups';

const ToastFail: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(3.2, 3.2, props)}>
        <path
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.139 16c0 5.596-4.537 10.133-10.134 10.133-5.596 0-10.133-4.537-10.133-10.134 0-5.596 4.537-10.133 10.133-10.133 5.597 0 10.134 4.537 10.134 10.133Zm3.2 0c0 7.363-5.97 13.333-13.334 13.333S2.672 23.363 2.672 15.999c0-7.363 5.97-13.333 13.333-13.333 7.364 0 13.334 5.97 13.334 13.333ZM17.605 8.665v8.667h-3.2V8.666h3.2Zm.4 12.667a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
        />
    </svg>
);

const ToastBookmark: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(3.2, 3.2, props)}>
        <path d="M7.333 4.667h17.334V28L16 23.265 7.333 28V4.666Z" />
    </svg>
);

const ToastNotInterested: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(3.2, 3.2, props)}>
        <path
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 28.667c6.996 0 12.667-5.672 12.667-12.667 0-6.996-5.671-12.667-12.667-12.667C9.005 3.333 3.334 9.004 3.334 16c0 6.995 5.67 12.667 12.666 12.667ZM9.667 18.4h12.667v-4.8H9.667v4.8Z"
        />
    </svg>
);

const ToastSuccess: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(3.2, 3.2, props)}>
        <path
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            d="m29.453 8.476-16 15.667-1.132 1.107-1.12-1.12-8.666-8.666 2.263-2.263 7.547 7.547L27.214 6.19l2.239 2.287Z"
            clipRule="evenodd"
        />
    </svg>
);

const ToastUnbookmark: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(3.2, 3.2, props)}>
        <path
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            d="m16 23.333 5.8 3.008L25 28V5H7v23l3.2-1.66 5.8-3.007Zm-5.8-.597 4.327-2.244L16 19.73l1.473.764 4.327 2.243V8.2H10.2v14.536Z"
        />
    </svg>
);

const ToastUndoNotInterested: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(3.2, 3.2, props)}>
        <path
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.133 16c0 5.597-4.537 10.133-10.133 10.133-5.597 0-10.133-4.536-10.133-10.133 0-5.596 4.536-10.133 10.133-10.133 5.596 0 10.133 4.537 10.133 10.133Zm3.2 0c0 7.364-5.97 13.333-13.333 13.333-7.364 0-13.334-5.97-13.334-13.333C2.666 8.636 8.636 2.667 16 2.667S29.333 8.637 29.333 16ZM10 18.4h12v-4.8H10v4.8Z"
        />
    </svg>
);

const ToastDone: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(3.2, 3.2, props, '0 0 48 48')}>
        <path
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M44.1791 12.7148L20.1791 36.2148L18.4822 37.8763L16.8029 36.1971L3.80294 23.1971L7.19706 19.8029L18.5178 31.1237L40.8209 9.28517L44.1791 12.7148Z"
        />
    </svg>
);

const ToastIcon: FunctionComponent<{ type: ToastNotification['type'] } & SvgProps> = ({
    type,
    ...props
}) => {
    switch (type) {
        case 'BOOKMARK':
            return <ToastBookmark {...props} />;
        case 'DONE':
            return <ToastDone {...props} />;
        case 'FAIL':
            return <ToastFail {...props} />;
        case 'NOTINTERESTED':
            return <ToastNotInterested {...props} />;
        case 'SUCCESS':
            return <ToastSuccess {...props} />;
        case 'UNBOOKMARK':
            return <ToastUnbookmark {...props} />;
        case 'UNDONOTINTERESTED':
            return <ToastUndoNotInterested {...props} />;
        default:
            return null;
    }
};

export default ToastIcon;
